export default "__VITE_ASSET__Cso59CU0__"